import { Navigate, Outlet } from 'react-router';
import { useIntelligenceAudienceAccess, useSearchParams } from '@/lib/hooks';
import { ROUTES } from '@/lib/constants/routes';
import { useAuthStore } from '@/stores/auth-store';
import { CLIENT_PARAM, isForeignClient } from './lib';

/**
 * Gates the audience page and its account and contact profile pages on
 * `intelligence-audience-switcher`.
 *
 * **Redirects home**, like the app's other guards. The bare `/intelligence` (once the
 * Explore page, NPJB-790) sits inside this guard too, so a blocked user never lands on it.
 * A client user on a URL carrying another account's `?client=` goes home too (NPJB-894).
 *
 * Renders nothing while the flag resolves: the check is a fast client-side resolve, and a
 * spinner that flashes before the page's own skeleton reads as a broken page rather than as
 * loading.
 */
export const IntelligenceProfileGuard = () => {
  const { allowed, ready } = useIntelligenceAudienceAccess();
  const user = useAuthStore((s) => s.user);
  const isInternal = useAuthStore((s) => s.isInternal);
  const client = useSearchParams().get(CLIENT_PARAM);
  if (isForeignClient(client, user, isInternal)) return <Navigate to={ROUTES.home} replace />;
  if (!ready) return null;
  return allowed ? <Outlet /> : <Navigate to={ROUTES.home} replace />;
};
